/*
  JDG IMG Comfort Swatch Selector — Norway vendor products
  Handles option name "Leather" with PRIME / TREND / SAUVAGE tiers
  Tier 1: PRIME (base price) | Tier 2: TREND (+$150) | Tier 3: SAUVAGE (+$150)
  Stock colors: Black - PRIME & Latte - PRIME → Ships in 5–7 Business Days
  All other colors → Special Order – 12–14 Weeks
*/
(function () {

  /* ── Stock colors (ship fast) ── */
  var STOCK_COLORS = ["Black - PRIME", "Latte - PRIME"];

  /* ── Color map: hex values for each swatch ── */
  var SW = {
    /* PRIME - Tier 1 */
    "Black - PRIME":       "#1a1a1e",
    "Latte - PRIME":       "#b8a88a",
    "Grey - PRIME":        "#6b6f72",
    "Coffee - PRIME":      "#2e2622",
    "Cloud - PRIME":       "#c4c4bc",
    "Rust - PRIME":        "#a0402a",
    "Olive - PRIME":       "#7a7d62",
    "Whisper - PRIME":     "#ddd5bc",
    "Tuscan - PRIME":      "#8b5e3c",
    "Jade - PRIME":        "#4a6b6a",
    "Shadow Blue - PRIME": "#3a4a5a",
    "Dark Caramel - PRIME":"#6b3a1f",
    /* TREND - Tier 2 */
    "Tuxedo - TREND":      "#1a1c2a",
    "Nature - TREND":      "#c4752a",
    "Snow - TREND":        "#ede8d5",
    "Pebble - TREND":      "#9a8c7e",
    "Pacific - TREND":     "#2e4052",
    "Graphite - TREND":    "#5a5852",
    "Cinder - TREND":      "#a0a09a",
    "Beige - TREND":       "#c8b890",
    "Storm - TREND":       "#9a9ea0",
    "Nordic Grey - TREND": "#8a8c8a",
    "Biscuit - TREND":     "#d4c4a0",
    "Whiskey - TREND":     "#b46830",
    "Lake Blue - TREND":   "#6a8ea8",
    "Sienna - TREND":      "#b86450",
    "Scarlet - TREND":     "#8a2030",
    "Moss - TREND":        "#7a8070",
    "Camel - TREND":       "#b48040",
    "Mocca - TREND":       "#3e2e2e",
    "Earth - TREND":       "#7a6858",
    "Lagoon - TREND":      "#a0a8a8",
    "Ocean - TREND":       "#3a4448",
    "Arctic Grey - TREND": "#d4cfc0",
    /* SAUVAGE - Tier 3 */
    "Nutmeg - SAUVAGE":    "#8a4030",
    "Truffle - SAUVAGE":   "#2a1a18",
    "Dove - SAUVAGE":      "#6a7070",
    "Charcoal - SAUVAGE":  "#282a28",
    "Anthracite - SAUVAGE":"#3a3c3c",
    "Caramel - SAUVAGE":   "#6a3020",
    "Oxblood - SAUVAGE":   "#4a1818",
    "Amber - SAUVAGE":     "#b87030",
    "Stone - SAUVAGE":     "#7a7870"
  };

  /* ── Tier info ── */
  var TIERS = {
    'PRIME':   { label: 'Prime',   desc: 'Top grain corrected leather, 0.8–1.0mm. Uniform appearance, excellent durability and easy cleaning.' },
    'TREND':   { label: 'Trend',   desc: 'Top grain slightly corrected leather, 0.9–1.1mm. Rich feel with fine grain texture. +$150 upgrade.' },
    'SAUVAGE': { label: 'Sauvage', desc: 'Natural milled top grain, ~1mm. Exceptionally soft with visible grain and two-tone patina effect. +$150 upgrade.' }
  };

  /* ── CSS ── */
  var s = document.createElement('style');
  s.textContent =
    '.jdg-img-tier-tabs{display:flex;gap:6px;margin-bottom:10px;flex-wrap:wrap}' +
    '.jdg-img-tier-tab{padding:5px 14px;border-radius:20px;border:1.5px solid #D4CCC3;font-size:12px;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;background:#fff;color:#6B6560;transition:all .15s}' +
    '.jdg-img-tier-tab.on{border-color:#1c1c1c;background:#1c1c1c;color:#fff}' +
    '.jdg-img-tier-tab[data-tier="TREND"].on,.jdg-img-tier-tab[data-tier="SAUVAGE"].on{border-color:#B89A6A;background:#B89A6A}' +
    '.jdg-img-tier-desc{font-size:11px;color:#8A7F75;margin-bottom:8px;line-height:1.5;padding:6px 10px;background:#FAF8F5;border-radius:5px}' +
    '.jdg-sw-grid{display:flex;flex-wrap:wrap;gap:8px;margin-top:6px}' +
    '.jdg-sw-tile{width:52px;height:52px;flex-shrink:0;position:relative;border:2px solid #C8C0B6;border-radius:6px;overflow:hidden;cursor:pointer;transition:border-color .15s,transform .15s}' +
    '.jdg-sw-tile:hover{border-color:#8A7F75;transform:scale(1.1);z-index:5}' +
    '.jdg-sw-tile.on{border-color:#1c1c1c;box-shadow:0 0 0 2px #1c1c1c}' +
    '.jdg-sw-tile .swatch-fill{width:100%;height:100%;display:block}' +
    '.jdg-sw-tile.on::after{content:"✓";position:absolute;top:2px;right:3px;width:14px;height:14px;background:#1c1c1c;color:#fff;font-size:9px;border-radius:50%;display:flex;align-items:center;justify-content:center;line-height:14px;text-align:center;font-weight:bold}' +
    '.jdg-sw-tip{position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:rgba(28,28,28,.9);color:#fff;font-size:10px;white-space:nowrap;padding:3px 8px;border-radius:4px;pointer-events:none;opacity:0;transition:opacity .12s;z-index:20}' +
    '.jdg-sw-tile:hover .jdg-sw-tip{opacity:1}' +
    /* Shipping badge */
    '.jdg-ship-badge{display:inline-flex;align-items:center;gap:6px;margin-top:12px;padding:7px 12px;border-radius:6px;font-size:12px;font-weight:500;letter-spacing:.02em}' +
    '.jdg-ship-badge.stock{background:#EAF5EC;color:#2A7A3B;border:1px solid #B8DFC0}' +
    '.jdg-ship-badge.special{background:#FFF8EC;color:#8A6020;border:1px solid #E8D8A8}' +
    '.jdg-ship-badge .ship-icon{font-size:14px}' +
    /* Zoom popup */
    '#jdg-img-zoom{position:fixed;z-index:99999;width:260px;background:#fff;border:1px solid #e0d8d0;border-radius:10px;box-shadow:0 12px 48px rgba(0,0,0,.22);overflow:hidden;opacity:0;transform:scale(.92);transition:opacity .2s,transform .2s;pointer-events:none}' +
    '#jdg-img-zoom.on{opacity:1;transform:scale(1);pointer-events:auto}' +
    '#jdg-img-zoom .zi{width:100%;aspect-ratio:1;overflow:hidden}' +
    '#jdg-img-zoom .zi .swatch-fill-lg{width:100%;height:100%;display:block}' +
    '#jdg-img-zoom .zb{padding:12px 14px 14px}' +
    '#jdg-img-zoom .zname{font-size:16px;font-weight:600;color:#1c1c1c;margin-bottom:2px}' +
    '#jdg-img-zoom .ztier{font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:#B89A6A;font-weight:500;margin-bottom:6px}' +
    '#jdg-img-zoom .zdesc{font-size:11px;color:#6B6560;line-height:1.55;margin-bottom:8px}' +
    '#jdg-img-zoom .zbadge{font-size:10px;color:#8A7F75;border-top:1px solid #ece7e0;padding-top:6px}';
  document.head.appendChild(s);

  /* ── Zoom popup (color block) ── */
  var zEl, zFill, zName, zTier, zDesc, hideT;

  function buildZoom() {
    if (document.getElementById('jdg-img-zoom')) {
      zEl   = document.getElementById('jdg-img-zoom');
      zFill = zEl.querySelector('.swatch-fill-lg');
      zName = zEl.querySelector('.zname');
      zTier = zEl.querySelector('.ztier');
      zDesc = zEl.querySelector('.zdesc');
      return;
    }
    zEl = document.createElement('div');
    zEl.id = 'jdg-img-zoom';
    zEl.innerHTML =
      '<div class="zi"><div class="swatch-fill-lg"></div></div>' +
      '<div class="zb">' +
        '<div class="zname"></div>' +
        '<div class="ztier"></div>' +
        '<div class="zdesc"></div>' +
        '<div class="zbadge">IMG Comfort — Scandinavian Design</div>' +
      '</div>';
    document.body.appendChild(zEl);
    zFill = zEl.querySelector('.swatch-fill-lg');
    zName = zEl.querySelector('.zname');
    zTier = zEl.querySelector('.ztier');
    zDesc = zEl.querySelector('.zdesc');
    zEl.addEventListener('mouseenter', function(){ clearTimeout(hideT); });
    zEl.addEventListener('mouseleave', scheduleHide);
  }

  function showZoom(tile, val, hex) {
    clearTimeout(hideT);
    buildZoom();
    var parts     = val.split(' - ');
    var colorName = parts[0] || val;
    var tierKey   = parts[1] || '';
    var tier      = TIERS[tierKey] || { label: tierKey, desc: '' };
    zFill.style.cssText = 'width:100%;height:100%;background:' + hex + ';display:block';
    zName.textContent = colorName;
    zTier.textContent = tier.label;
    zDesc.textContent = tier.desc;
    /* Position next to product image */
    var pw = 260, gap = 16;
    var imgEl = document.querySelector('.jdg-product-main-img, .product__media img, .product-single__photo img');
    var sy = window.scrollY;
    var top, left;
    if (imgEl) {
      var ir = imgEl.getBoundingClientRect();
      top  = ir.top + sy + (ir.height / 2) - 160;
      left = ir.right + gap;
      if (left + pw > window.innerWidth - 8) left = ir.left - pw - gap;
      top  = Math.max(sy + 8, top);
    } else {
      var r = tile.getBoundingClientRect();
      top  = r.top + sy - 300;
      left = Math.max(8, r.left - pw - gap);
    }
    zEl.style.cssText = 'top:'+top+'px;left:'+left+'px;width:'+pw+'px';
    zEl.classList.add('on');
  }

  function scheduleHide() {
    hideT = setTimeout(function(){ if(zEl) zEl.classList.remove('on'); }, 220);
  }

  /* ── Shipping badge helper ── */
  function updateShippingBadge(badge, val) {
    if (!badge) return;
    var isStock = STOCK_COLORS.indexOf(val) !== -1;
    if (isStock) {
      badge.className = 'jdg-ship-badge stock';
      badge.innerHTML = '<span class="ship-icon">✅</span> Ships in 5–7 Business Days';
    } else {
      badge.className = 'jdg-ship-badge special';
      badge.innerHTML = '<span class="ship-icon">🕐</span> Special Order – 12–14 Weeks';
    }
  }

  /* ── Main init ── */
  function init() {
    document.querySelectorAll('.jdg-pp-opt-group').forEach(function(group) {
      var lbl = group.querySelector('.jdg-pp-opt-lbl');
      if (!lbl) return;
      var optName = lbl.textContent.replace(/:.*/, '').trim();
      if (optName !== 'Leather') return;

      var btnRow = group.querySelector('.jdg-pp-opt-row');
      if (!btnRow || btnRow.dataset.imgSw) return;
      btnRow.dataset.imgSw = '1';

      var btns = Array.from(btnRow.querySelectorAll('.jdg-pp-ob'));
      if (!btns.length) return;

      /* Group buttons by tier */
      var byTier = { PRIME: [], TREND: [], SAUVAGE: [] };
      btns.forEach(function(btn) {
        var parts = (btn.dataset.v || '').split(' - ');
        var tier  = parts[1] || 'PRIME';
        if (!byTier[tier]) byTier[tier] = [];
        byTier[tier].push(btn);
      });

      /* Build tier tab bar */
      var tabBar = document.createElement('div');
      tabBar.className = 'jdg-img-tier-tabs';

      var tierDesc = document.createElement('div');
      tierDesc.className = 'jdg-img-tier-desc';

      /* Shipping badge */
      var shipBadge = document.createElement('div');
      shipBadge.className = 'jdg-ship-badge stock';
      shipBadge.innerHTML = '<span class="ship-icon">✅</span> Ships in 5–7 Business Days';

      var grids = {};
      var activeTier = 'PRIME';

      /* Find currently selected value */
      var currentVal = '';
      btns.forEach(function(btn) {
        if (btn.classList.contains('on')) currentVal = btn.dataset.v || '';
      });
      if (!currentVal && btns.length) currentVal = btns[0].dataset.v || '';
      updateShippingBadge(shipBadge, currentVal);

      ['PRIME', 'TREND', 'SAUVAGE'].forEach(function(tierKey) {
        if (!byTier[tierKey] || !byTier[tierKey].length) return;

        var tab = document.createElement('button');
        tab.className = 'jdg-img-tier-tab' + (tierKey === 'PRIME' ? ' on' : '');
        tab.dataset.tier = tierKey;
        tab.textContent = TIERS[tierKey].label + (tierKey !== 'PRIME' ? ' +$150' : '');
        tabBar.appendChild(tab);

        /* Build swatch grid for this tier */
        var grid = document.createElement('div');
        grid.className = 'jdg-sw-grid';
        grid.style.display = tierKey === 'PRIME' ? '' : 'none';
        grids[tierKey] = grid;

        byTier[tierKey].forEach(function(btn) {
          var val = btn.dataset.v;
          var hex = SW[val] || '#ccc';

          var tile = document.createElement('div');
          tile.className = 'jdg-sw-tile' + (btn.classList.contains('on') ? ' on' : '');

          var fill = document.createElement('div');
          fill.className = 'swatch-fill';
          fill.style.cssText = 'width:100%;height:100%;background:' + hex;
          tile.appendChild(fill);

          var tip = document.createElement('div');
          tip.className = 'jdg-sw-tip';
          tip.textContent = val.split(' - ')[0];
          tile.appendChild(tip);

          /* Hover zoom */
          var ht;
          tile.addEventListener('mouseenter', function() {
            ht = setTimeout(function(){ showZoom(tile, val, hex); }, 180);
          });
          tile.addEventListener('mouseleave', function() {
            clearTimeout(ht); scheduleHide();
          });

          /* Click */
          tile.addEventListener('click', function() {
            btn.click();
            /* Uncheck all tiles across all tiers */
            Object.values(grids).forEach(function(g) {
              g.querySelectorAll('.jdg-sw-tile').forEach(function(t){ t.classList.remove('on'); });
            });
            tile.classList.add('on');
            var sp = lbl.querySelector('span');
            if (sp) sp.textContent = val;
            /* Update shipping badge */
            updateShippingBadge(shipBadge, val);
          });

          /* Sync */
          new MutationObserver(function() {
            tile.classList.toggle('on', btn.classList.contains('on'));
          }).observe(btn, { attributes: true, attributeFilter: ['class'] });

          grid.appendChild(tile);
        });

        /* Tab click */
        tab.addEventListener('click', function() {
          activeTier = tierKey;
          tabBar.querySelectorAll('.jdg-img-tier-tab').forEach(function(t){ t.classList.remove('on'); });
          tab.classList.add('on');
          Object.entries(grids).forEach(function(e){ e[1].style.display = e[0] === tierKey ? '' : 'none'; });
          tierDesc.textContent = TIERS[tierKey].desc;
        });
      });

      tierDesc.textContent = TIERS['PRIME'].desc;

      /* Hide original buttons */
      btnRow.style.cssText = 'display:none!important';

      /* Insert tab UI */
      btnRow.parentNode.insertBefore(tabBar, btnRow.nextSibling);
      btnRow.parentNode.insertBefore(tierDesc, tabBar.nextSibling);
      Object.values(grids).forEach(function(g) {
        tierDesc.parentNode.insertBefore(g, tierDesc.nextSibling);
      });

      /* Insert shipping badge after the last grid */
      var lastGrid = Object.values(grids).pop();
      if (lastGrid) {
        lastGrid.parentNode.insertBefore(shipBadge, lastGrid.nextSibling);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 150); });
  } else {
    setTimeout(init, 150);
  }

})();